import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  acceptTermsStatus(): any {
    return api.post('/termo-uso', null)
  },

  getTermsStatus(): any {
    return api.get('/termo-uso')
  },
}
